import React from 'react';
import styles from './LayeredTableHeader.module.scss';

const LayeredTableHeader = ({
  expandable,
  editable,
  deletable,
  rowDataPropertiesArray,
  expandButtonFlex,
}) => {
  return (
    <div key={`layered-table-header`} className={styles.header}>
      {expandable === 'start' && (
        <div key={`header-empty-expand`} className={styles.tableCell}>
          <div className={styles.expandButton} />
        </div>
      )}

      {rowDataPropertiesArray.map((prop, index) => {
        return (
          <div key={`header-${index}`} className={styles.tableCell}>
            {typeof prop.header === 'function' ? prop.header() : prop.header}
          </div>
        );
      })}
      {deletable && (
        <div
          key={`header-empty-delete`}
          className={styles.tableCell}
          style={{ flex: expandButtonFlex }}
        >
          <div className={styles.expandButton} />
        </div>
      )}
      {editable && (
        <div key={`header-empty-edit`} className={styles.tableCell}>
          <div className={styles.expandButton} />
        </div>
      )}
      {expandable === 'end' && (
        <div key={`header-empty-expand`} className={styles.tableCell}>
          <div className={styles.expandButton} />
        </div>
      )}
    </div>
  );
};

export default LayeredTableHeader;
